import { htmlSafe } from '@ember/template';
import Helper from '@ember/component/helper';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';

export default Helper.extend({
  formatDateService: service(),

  compute(args, namedArgs) {
    let val = args[0];
    if (isEmpty(val)) {
      return null;
    }
    let formatted = this.formatDateService.format(val, namedArgs);
    return htmlSafe(formatted);
  },
});
